/**
 * The opaque `{artifactId}` for a ledger entry — the uuid segment of its S3 key
 * (`workstreams/{ws}/artifacts/{uuid}/{filename}`, the ADR-0039 write layout;
 * ADR-0046 made that segment the wire identity). An off-layout key can't be
 * addressed and returns `null`, so callers skip it rather than firing a doomed
 * request or opening an un-fetchable tab.
 */
export function artifactIdOf(key: string): string | null {
  const parts = key.split('/');
  return parts.length === 5 && parts[0] === 'workstreams' && parts[2] === 'artifacts'
    ? (parts[3] ?? null)
    : null;
}
